import React from "react";
import MarkdownRenderer from "../common/MarkdownRenderer";

interface DailyMessageRendererProps {
  messageText: string;
  className?: string;
}

export const DailyMessageRenderer: React.FC<DailyMessageRendererProps> = ({
  messageText,
  className = ""
}) => {
  return (
    <div className={`daily-message-standalone ${className}`}>
      <div className="daily-message-standalone__content">
        <div className="chat-message__markdown">
          <MarkdownRenderer markdown={messageText} />
        </div>
      </div>
    </div>
  );
};
